(function () {
  /* ---- product page: variant picker, qty, thumbnails ---- */
  var json = document.querySelector('[data-product-json]');
  if (json) {
    var variants = JSON.parse(json.textContent);
    var form = document.querySelector('.pdp-form');
    var idInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = document.querySelector('[data-add-btn]');
    var qtyVal = document.getElementById('q-val');
    var qtyInput = document.querySelector('[data-qty-input]');
    var qty = 1;

    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    function currentOptions() {
      var opts = [];
      form.querySelectorAll('.sizes').forEach(function (group, i) {
        var checked = group.querySelector('input:checked');
        opts[i] = checked ? checked.value : null;
      });
      return opts;
    }
    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      }
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) update();
      });
      update();
    }
    var minus = document.getElementById('q-minus'), plus = document.getElementById('q-plus');
    function setQty(n) { qty = Math.min(9, Math.max(1, n)); if (qtyVal) qtyVal.textContent = qty; if (qtyInput) qtyInput.value = qty; }
    if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

    var main = document.getElementById('pdp-img');
    document.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () { if (main && t.dataset.full) main.src = t.dataset.full; });
    });
  }
})();
